import React from 'react';
import { IconSvgProps } from '@models/common';

const ChevronDown: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      stroke='currentColor'
      fill='none'
      viewBox='0 0 24 24'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='m6 9.5 6 6 6-6'
      />
    </svg>
  );
};

export default ChevronDown;
